export function submitAddAdminBranch()
{
    return({
        type:"SUBMIT_ADD_ADMIN_BRANCH"
    })
}